import React, { Component } from "react";
import "./menu-auxiliary.scss";

export default class MenuAuxiliary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listPages: [
        {
          title: "Home",
          image: require("../../rsc/assets/profile.png"),
          path: "#/",
        },
        {
          title: "Services",
          image: require("../../rsc/assets/iconServices.svg"),
          path: "#/Services",
        },
        {
          title: "Tools",
          image: require("../../rsc/assets/iconTools.svg"),
          path: "#/Tools",
        },
        // {
        //   title: "Experience",
        //   image: require("../../rsc/assets/iconExperience.svg"),
        //   path: "#/Experience",
        // },
        {
          title: "Advantages",
          image: require("../../rsc/assets/iconAdvantages.svg"),
          path: "#/Advantages",
        },
      ],
      pageActive: 0,
    };
  }

  render() {
    const { state } = this;
    let contentPages = [];
    contentPages = state.listPages.map((page) =>
      this.itemAux(
        page.title,
        page.image,
        page.path,
        window.location.hash === page.path
      )
    );
    return (
      <div className={"d-f fd-r ai-st jc-c zi-1 wi-60 jc-sa "}>
        {contentPages}
      </div>
    );
  }

  itemAux = (title, asset, path, active) => {
    var customClas = "bord-0";
    if (active) {
      customClas = "it-aux-act cur-none -pe";
    }
    return (
      <a
        href={path}
        className={`item-auxi ai-c jc-c d-fl bord-r2 ${customClas}`}
      >
        <span>{title}</span>
        <abbr title={title}>
          <img className={"img-medal-new"} src={asset.default} alt="" />
        </abbr>
      </a>
    );
  };
}
